import { useId } from 'vue';

export function useAttrSelector(prefix='ui') {
  const idx = useId();
  return `${prefix}${idx.replace('v-', '').replaceAll('-', '_')}`;
}
